export default {
  AG_YOU_ARE: 'youAre',
  AG_START: 'start',
  AG_CHANGES: 'changes',
  AG_ERROR: 'error',

  AG_SET_DYNAMIC: 'setDynamic',
  AG_SWITCHABLE_CALC: 'addSwitchableCalc'
};
